import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { seo } from "../translations/seo";

const H2 = "font-outfit text-xl font-bold text-slate-800 mb-3";
const LINK = "text-[#2E4DB5] underline";

const Row = ({ label, children }) => (
  <li><strong className="text-slate-800">{label} :</strong> {children}</li>
);

export default function Legal() {
  const { language } = useLanguage();
  return (
    <div className="min-h-screen bg-white font-jakarta">
      <Navbar />
      <Seo title={seo[language].legal.title} description={seo[language].legal.description} />
      <div className="pt-28 pb-24 max-w-3xl mx-auto px-6 sm:px-8" data-testid="legal-page">
        <h1 className="font-outfit text-4xl font-bold text-slate-900 mb-2">Mentions légales</h1>
        <p className="text-slate-400 text-sm mb-10 pb-6 border-b border-slate-100">
          Informations prévues par le Code de droit économique (livre XII)
        </p>

        <div className="space-y-8 text-slate-600 text-base leading-relaxed">
          <section>
            <h2 className={H2}>1. Éditeur du site</h2>
            <ul className="space-y-2" data-testid="legal-publisher">
              <Row label="Nom">Benedetta Branchesi</Row>
              <Row label="Forme juridique">personne physique, indépendant</Row>
              <Row label="Numéro d’entreprise (BCE)">0663580661</Row>
              <Row label="Siège">Avenue de la Renaissance 21, 1000 Bruxelles, Belgique</Row>
              <Row label="E-mail"><a href="mailto:dottbb@outlook.com" className={LINK}>dottbb@outlook.com</a></Row>
              <Row label="Téléphone"><a href="tel:+32465647108" className={LINK}>+32 465 64 71 08</a></Row>
            </ul>
          </section>

          <section>
            <h2 className={H2}>2. Hébergement</h2>
            <ul className="space-y-2">
              <Row label="Site web">Emergent</Row>
              <Row label="Domaine et messagerie">GigaWeb</Row>
            </ul>
          </section>

          <section>
            <h2 className={H2}>3. Propriété intellectuelle</h2>
            <p>L’ensemble des contenus de ce site (textes, photographies, logo) est protégé par le droit d’auteur. Toute reproduction sans autorisation préalable est interdite.</p>
          </section>

          <section>
            <h2 className={H2}>4. Responsabilité</h2>
            <p>Les informations publiées sur ce site sont fournies à titre informatif et ne remplacent pas une consultation médicale. En cas d’urgence, appelez le 112.</p>
          </section>

          <section>
            <h2 className={H2}>5. Données personnelles</h2>
            <p>Le traitement de vos données est décrit dans notre{" "}
              <Link to="/confidentialite" className={LINK} data-testid="legal-privacy-link">politique de confidentialité</Link>.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-100">
          <Link to="/" className="text-[#2E4DB5] font-semibold hover:opacity-70 transition-opacity">
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
